import {AfterViewInit, Directive, ElementRef, inject, Input} from '@angular/core';

@Directive({
  selector: '[mxHiddenUntilLoaded]'
})
export class HiddenUntilLoadedDirective implements AfterViewInit {

  @Input()
  public set reveal(reveal: boolean) {
    this.elementClassList[reveal ? 'add' : 'remove']('mx-reveal');
  }

  private readonly elementClassList: DOMTokenList = (inject(ElementRef).nativeElement as Element).classList;

  public ngAfterViewInit(): void {
    this.elementClassList.add('mx-hidden-until-loaded');
  }
}
